import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO__grid2d_cell } from '../grid2d_cell/DTO__grid2d_cell';
import { DTO__grid2d_chunk_generic } from './DTO__grid2d_chunk_generic';

export class DTO__grid2d_chunk extends DTO__grid2d_chunk_generic<DTO__grid2d_cell> {
  static _class_name_static: string = ENUM__dto_class_name.GRID2D_CHUNK;
}
